import { render, staticRenderFns } from "./PersonWithStatus.vue?vue&type=template&id=4e4c7a9d&scoped=true"
import script from "./PersonWithStatus.vue?vue&type=script&lang=js"
export * from "./PersonWithStatus.vue?vue&type=script&lang=js"
import style0 from "./PersonWithStatus.vue?vue&type=style&index=0&id=4e4c7a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c7a9d",
  null
  
)

export default component.exports